import axios, { AxiosInstance, AxiosPromise, AxiosRequestConfig, AxiosResponse } from 'axios';
import qs from 'qs';

interface BaseHttpResponse {
  code?: string;
  error?: string;
}

const RESPONSE_CODE_ERROR = 'error';

// LEGACY CODE
export default abstract class HttpApi {
  protected http: AxiosInstance;

  constructor(protected basePath: string, baseURL: string = 'api') {
    this.http = axios.create({
      baseURL: `/${baseURL}${basePath}`,
      timeout: 30000,
      withCredentials: true,
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Access-Control-Allow-Origin': '*',
        ...(process.env.REACT_APP_USER && {
          'X-Auth-Username': process.env.REACT_APP_USER,
        }),
      },
    });
  }

  get<T extends BaseHttpResponse>(url: string, config?: AxiosRequestConfig) {
    return response<T>(this.http.get(url, config));
  }

  post<T extends BaseHttpResponse>(url: string, data?: any, config?: AxiosRequestConfig) {
    return response<T>(this.http.post(url, data, config));
  }

  put<T extends BaseHttpResponse>(url: string, data?: any, config?: AxiosRequestConfig) {
    return response<T>(this.http.put(url, data, config));
  }

  delete<T extends BaseHttpResponse>(url: string, config?: AxiosRequestConfig) {
    return response<T>(this.http.delete(url, config));
  }

  patch<T extends BaseHttpResponse>(url: string, data?: any, config?: AxiosRequestConfig) {
    return response<T>(this.http.patch(url, data, config));
  }
}

/**
 * Response middleware.
 * Checks whether network response contains error, or correct data
 */
export async function response<T extends BaseHttpResponse>(request: AxiosPromise<T>) {
  try {
    const response: AxiosResponse<T> = await request;
    const { data } = response;

    let code: null | string = null;

    if (data != null && data.code != null) {
      code = String(data.code).toLowerCase();
    }

    if (code === RESPONSE_CODE_ERROR) {
      throw data;
    }

    return data;
  } catch (error) {
    const { response } = error;

    if (response != null) {
      const { status } = response;

      if (response.data != null) {
        throw { ...response.data, status };
      }
    }

    throw error;
  }
}